export default "__VITE_ASSET__DIAu_p71__"